function isIEorEdge() {
        return document.documentMode;
      }
      
      if (isIEorEdge()) {
        alert("Please use Google Chrome, Firefox or Opera to view this fair.");
        window.location = 'https://www.saxton.tech';
      } 
